<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>

    <a-card class="all-card-style ">

      <a-form-model ref="workModel" :rules="FormRules"  :model="workModel"  :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">

        <a-form-model-item prop="cPlatformID" label="所属项目"  class="ant-form-item2 ">
          <a-select v-model="workModel.cPlatformID" @change="platformSelect"  class="ant-form-item3 ">
            <a-select-option v-for="(item,index) in platformSelectItems" :value="item.ID">
              {{item.cPlatformName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="cSceneID" label="所属场地" class="ant-form-item2 " >
          <a-select v-model="workModel.cSceneID"  @change="sceneformSelect" class="ant-form-item3 " >
            <a-select-option v-for="(item,index) in sceneformSelectItems" :value="item.ID">
              {{item.cSceneName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>


         <a-form-model-item   prop="cCropNameID" label="作物名称" class="ant-form-item2">
         <a-select v-model="workModel.cCropNameID"
        class="ant-form-item3"
          >
           <a-select-option v-for="(item,index) in cropNameSelectItems" :value="item.ID">
             {{item.cDicName}}
           </a-select-option>
        </a-select>

        </a-form-model-item>

         <a-form-model-item prop="cFarmingContentID" label="农事内容" class="ant-form-item2">
         <a-select   v-model="workModel.cFarmingContentID" class="ant-form-item3"
          >
           <a-select-option v-for="(item,index) in farmingContentIDSelectItems" :value="item.ID">
             {{item.cDicName}}
           </a-select-option>
        </a-select>

        </a-form-model-item>
         <a-form-model-item prop="cWorkOrderID"     label="工单管理" class="ant-form-item2">
         <a-select  v-model="workModel.cWorkOrderID" class="ant-form-item3"
          >
           <a-select-option v-for="(item,index) in workOrderSelectItems" :value="item.ID">
             {{item.cTaskName}}
           </a-select-option>
        </a-select>
          <!-- <a-input v-model="model.cTaskContent" placeholder="请输入" :rows="3" /> -->
        </a-form-model-item>
         <a-form-model-item  prop="cOptUser"  label="操作人" class="ant-form-item2">
           <a-select
             placeholder="请选择" v-model="workModel.cOptUser"   class="ant-form-item3"
           >

             <a-select-option v-for="(item,index) in userSelectItems" :value="item.ID">
               {{item.cUserName}}
             </a-select-option>

           </a-select>
          <!-- <a-input v-model="model.cTaskContent" placeholder="请输入" :rows="3" /> -->
        </a-form-model-item>


         <a-form-model-item  prop="dOptDate" label="操作时间" class="ant-form-item2">
           <a-date-picker v-model="workModel.dOptDate" placeholder="请选择操作时间" />
        </a-form-model-item>
         <a-form-model-item   prop="iWorkingHours" label="工时" class="ant-form-item2">
          <a-input v-model="workModel.iWorkingHours" placeholder="请输入" :rows="3" />
        </a-form-model-item>
        <a-form-model-item   prop="cPic" label="农事图片" class="ant-form-item2">


          <a-upload
            :action="uploadurl"
            list-type="picture"
            :default-file-list="fileList"
            @change="uploadchange"
          >
            <a-button> <a-icon type="upload" /> upload </a-button>
          </a-upload>

        </a-form-model-item>
           <a-form-model-item   prop="cContents" label="内容" class="ant-form-item2">
          <a-input v-model="workModel.cContents" placeholder="请输入" :rows="3" />
        </a-form-model-item>





        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>
        </a-form-model-item>

      </a-form-model>


    </a-card>
  </div>
</template>



<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData,_getAllUser } from '@/common/request'

  export default {
    name: 'diseaseForm',
    components: {
      TitleCard
    },
    data() {
      return {
        uploadurl:"",
        fileList:[],
        platformSelectItems:[],
        sceneformSelectItems:[],
        cropNameSelectItems:[],
        farmingContentIDSelectItems :[],

        userSelectItems:[],
        queryPlatformInfo:{
          cEntID:"",
          keyword:""
        },
        titleMsg1: "生产管理",
        titleMsg2:'农事记录',
        titleMsg3:'农事记录',
        titleMsg4:'工单管理',
        workModel:{},
        cEntID:"",
        FormRules:{
          cCropNameID: [
            { required: true, message: '请选择作物名称', trigger: 'change' }
          ],
          cPlatformID:[
            { required: true, message: '请选择所属项目', trigger: 'change' }
          ],
          cSceneID:[
            { required: true, message: '请选择所属场地', trigger: 'change' }
          ],
          cFarmingContentID: [
            { required: true, message: '请选择作物名称', trigger: 'change' }
          ],
          cOptUser:[
            { required: true, message: '请选择实施人员', trigger: 'change' }
          ],
          dOptDate:[
            { required: true, message: '请选择操作时间', trigger: 'change' }
          ],
          iWorkingHours:[
            { required: true, message: '请输入工时', trigger: 'blur' }
          ],
          cContents:[
            { required: true, message: '请输入内容', trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
      let that=this;
      that.uploadurl=that.$http.defaults.baseURL+"User/Upload";
      that.queryPlatformInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.workModel.cEntID=that.$store.getters.User.enterprise.ID;

      if (that.$route.params.sceneId){
        // that.workModel.sceneId=that.$route.params.sceneId;
      }
      that.getEntPlatFormData()
      if (that.$route.params.ID){
        that.workModel.ID=that.$route.params.ID;
        that.HandleDetail();
      }

      that.workModel.cSceneID=that.$store.getters.SCene.ID;
      that.workModel.cSceneName=that.$store.getters.SCene.cSceneName;

      that.getAllUser();
      that.getCropNameData();
      that.getFarmingContentIDData();
      that.getWorkOrder();
    },

    methods:{


      uploadchange(e){
        console.log('e.file.response.Id',e.file.response.Id);
        let that=this;

        if (e.file){

          that.fileList.push({
            uid:e.file.response.Id,
            name: e.file.response.Id,
            status: 'done',
            response: '', // custom error message to show
            url: that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+e.file.response.Id,
          })




        }

      },




      platformSelect(){

        this.getSceneData()
      },
      async getAllUser(){
        console.log('getAllUser',2222222);
        let that=this
        let res=await _getAllUser(this,this.queryPlatformInfo);
        console.log(res);
        if(res.code=='200'){
          that.userSelectItems=res.obj.list
        }
      },
async getWorkOrder(){
  var that=this
  let res=await that.$http.post('EntWorkOrderTask/List',{cSystemCode:'节水灌溉'
  })
  if(res.data.code=='200'){
    that.workOrderSelectItems=res.data.obj.list
  }
},
      /*获取项目列表*/
      async getEntPlatFormData(){
        var that=this
        let res=await  _getEntPlatFormData(this,this.queryPlatformInfo)


        if(res.data.data.code=="200"){

          that.platformSelectItems=res.data.data.obj.list
          if(that.platformSelectItems.length>0) {
            that.workModel.cPlatformID=that.platformSelectItems[0].ID

            this.getSceneData()
          }
        }

      },
      async getSceneData(){
        var that=this
        let res=await that.$http.post('EntSceneInfo/List',{cSystemCode:'节水灌溉',cPlatformID:that.workModel.cPlatformID})

        if(res.data.code=="200"){

          that.sceneformSelectItems=res.data.obj.list

          if(that.sceneformSelectItems.length>0) {
            that.workModel.cSceneID=that.sceneformSelectItems[0].ID
            that.workModel.cSceneName=that.sceneformSelectItems[0].cSceneName

          }
        }

      },
      async getCropNameData(){
        var that=this
        let param={dicClassCode: 'CropName'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code=='200'){
          that.cropNameSelectItems=res.data.obj.list
        }

      },
      async getFarmingContentIDData(){
        var that=this

        let param={dicClassCode: 'FarmingContent'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code='200'){
          that.farmingContentIDSelectItems=res.data.obj.list;
        }


      //  let res=await that.$http.post('FarmingContent/List',{});


      },
      async getKeySecretData(){
        var that=this
        let res=await that.$http.post('HkCamera/GetKeySecretList',{cEntID:that.$store.getters.User.enterprise.ID})

        if(res.data.code=="200"){

          that.AppKeySelectItems=res.data.obj.list

          if(that.AppKeySelectItems.length>0) {
            that.model.AppKey=that.AppKeySelectItems[0].cAppId
            that.model.APPSecret=that.AppKeySelectItems[0].cAppPwd

          }
        }

      },
      sceneformSelect(){
        let that=this;
        that.workModel.cSceneName=this.sceneformSelectItems.filter(s=>s.ID==that.workModel.cSceneID)
      },
      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntFarmingRecords/FindById/' + that.workModel.ID, null)

        if (res.data.code == "200") {
          that.workModel = res.data.obj.data;

if(that.workModel.cPic!=''){
  let picArr=that.workModel.cPic.split(',');
  if(picArr!=null&&picArr.length>0){
    for(let i=0;i<picArr.length;i++){

      that.fileList.push({
        uid:picArr[i],
        name: picArr[i],
        status: 'done',
        response: '', // custom error message to show
        url: that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+picArr[i],
      })
    }
  }
}




        } else {

        }
      },
      async SaveForms () {
        let that = this;
        let form=that.$refs['workModel'];
        form.validate(async valid => {

          let picArr=[];
          console.log('    that.fileList',     that.fileList);
          if(that.fileList!=null&&that.fileList.length>0){
            for(let i in that.fileList){
              let _url=(that.fileList[i].url)


              _url=_url.replace(that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4),'');
              picArr.push(_url);
            }
          }
          that.workModel.cPic=picArr.join(',');
          console.log('     that.workModel.cPic',     that.workModel.cPic);
          that.workModel.cSystemCode='节水灌溉';
          if (valid) {
            //url


            let res = await that.$http.post('EntFarmingRecords/Save', that.workModel)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({name:'FarmingRecordlist'});
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>

